
import React from "react";
import { Button, ButtonProps } from "@/components/ui/button";
import { Table2 } from "lucide-react";

interface DataTableButtonProps extends ButtonProps {
  onClick: () => void;
  label?: string;
}

const DataTableButton: React.FC<DataTableButtonProps> = ({ 
  onClick, 
  label = "View Data Tables", 
  ...props 
}) => {
  return (
    <Button
      variant="outline"
      size="sm"
      className="ml-auto flex items-center gap-1"
      onClick={onClick}
      {...props}
    >
      <Table2 className="h-4 w-4 mr-1" /> {label}
    </Button>
  );
};

export default DataTableButton;
